import { Autocomplete, TextField } from "@mui/material";
import React, { useState } from "react";
import { TipoDomicilioArray } from "../../../Arrays/TipoDomicilioArray";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ValidaDomicilio } from "./ValidaDomicilio";

import { useEffect } from "react";
import { useSelector } from "react-redux";

export const ModalDomicilioScreen = ({ orden, setDomicilios }) => {
  const { idcliente } = useSelector((store) => store.clientes);
  const closedModal = () => {
    var modal = document.getElementById("modal-domicilio");
    modal.style.display = "none";
  };

  const [arraylocalidades, setArrayLocalidades] = useState([]);
  const [state, setState] = useState({
    codigo_postal: "",
    estado: "",
    municipio: "",
    localidad: "",
    direccion: "",
    tipodomicilio: "",
    principal: "",
    referencia1: "",
    referencia2: "",
  });
  const onBuscar = () => {
    request
      .get(`Localidades/Listado?codigo_postal=${state.codigo_postal}`)
      .then((result) => {
        if (result.estado === undefined || result.estado === null) {
          Swal.fire("Clientes", "Codigo postal no valido", "warning");
          setArrayLocalidades([]);
          setState({
            ...state,
            estado: "",
            municipio: "",
            localidad: "",
            direccion: "",
            tipodomicilio: "",
            principal: "",
            referencia1: "",
            referencia2: "",
          });
        } else {
          setState({
            ...state,
            estado: result.estado.estado,
            municipio: result.estado.municipio,
            localidad: "",
          });
          setArrayLocalidades(result.localidades);
        }
      })
      .catch((error) => {
        Swal.fire("Clientes", JSON.stringify(error), "error");
        setArrayLocalidades([]);
        setState({
          ...state,
          estado: "",
          municipio: "",
          localidad: "",
          direccion: "",
          tipodomicilio: "",
          principal: "",
          referencia1: "",
          referencia2: "",
        });
      });
  };
  const onGuardar = () => {
    var valido = ValidaDomicilio(state);
    if (valido !== false) {
      valido.idcliente = Number(idcliente);
      valido.orden = Number(orden);
      request
        .post("ClientesDomicilio", valido)
        .then(async (result) => {
          await Swal.fire("Clientes", result.mensaje, "success");
          setDomicilios(result.domicilios);
          setState({
            codigo_postal: "",
            estado: "",
            municipio: "",
            localidad: "",
            direccion: "",
            tipodomicilio: "",
            principal: "",
            referencia1: "",
            referencia2: "",
          });
          closedModal();
        })
        .catch((error) => {
          Swal.fire("Clientes", JSON.stringify(error), "error");
        });
    }
  };

  useEffect(() => {
    if (orden !== undefined && orden !== null && Number(orden) > 0) {
      request
        .get(
          `ClientesDomicilio/ObtenerporOrden?idcliente=${Number(
            idcliente
          )}&orden=${Number(orden)}`
        )
        .then((result) => {
          setState({
            codigo_postal: result.codigo_postal,
            estado: result.estado,
            municipio: result.municipio,
            localidad: `${result.idlocalidad} - ${result.localidad}`,
            direccion: result.direccion,
            tipodomicilio: result.tipodomicilio,
            referencia1: result.referencia1,
            referencia2: result.referencia2,
          });
        })
        .catch((error) => {
          Swal.fire("Clientes", JSON.stringify(error), "error");
        });
    }
  }, [orden]);
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  };
  return (
    <div id="modal-domicilio" class="modal">
      <div class="modal-content-clientes">
        <div class="modal-header-domicilio">
          <span class="close" onClick={closedModal}>
            &times;
          </span>
          <div className="encabezado">
            <div className="titulo">
              {orden === 0 ? "REGISTRAR DOMICILIO" : "ACTUALIZAR DOMICILIO"}
            </div>
            <div className="border-green"></div>
          </div>
        </div>
        <div class="modal-body-clientes">
          <div className="modal-cliente-codigopostal">
            <TextField
              fullWidth
              label="Código Postal"
              size="small"
              color="success"
              className="w-cp"
              value={state.codigo_postal}
              onChange={({ target }) =>
                setState({
                  ...state,
                  codigo_postal: target.value.toUpperCase(),
                })
              }
              inputProps={{
                maxLength: 5,
              }}
            />
            <div
              className="modal-cliente-codigopostal-buscar"
              onClick={onBuscar}
            >
              Buscar
            </div>
          </div>
          <div className="col-2">
            <TextField
              disabled
              fullWidth
              label="Estado"
              size="small"
              color="success"
              className="w-50"
              value={state.estado}
              onChange={({ target }) =>
                setState({
                  ...state,
                  estado: target.value.toUpperCase(),
                })
              }
              inputProps={{
                maxLength: 50,
              }}
            />
            <TextField
              disabled
              fullWidth
              label="Municipio"
              size="small"
              color="success"
              className="w-50"
              value={state.municipio}
              onChange={({ target }) =>
                setState({
                  ...state,
                  municipio: target.value.toUpperCase(),
                })
              }
              inputProps={{
                maxLength: 50,
              }}
            />
          </div>
          <Autocomplete
            fullWidth
            size="small"
            id="idlocalidad"
            freeSolo
            className="mb-15"
            value={state.localidad}
            onChange={({ target }) =>
              setState({ ...state, localidad: target.outerText })
            }
            options={arraylocalidades.map(
              (option) => `${option.id} - ${option.display}`
            )}
            renderInput={(params) => (
              <TextField {...params} label="Localidad" />
            )}
            sx={{ mr: 1 }}
          />
          <Autocomplete
            fullWidth
            size="small"
            id="tipodomicilio"
            freeSolo
            className="mb-15"
            value={state.tipodomicilio}
            onChange={({ target }) =>
              setState({ ...state, tipodomicilio: target.outerText })
            }
            options={TipoDomicilioArray.map(
              (option) => `${option.id} - ${option.display}`
            )}
            renderInput={(params) => (
              <TextField {...params} label="Tipo de Domicilio" />
            )}
            sx={{ mr: 1 }}
          />
          <TextField
            fullWidth
            label="Dirección"
            size="small"
            color="success"
            className="mb-15"
            value={state.direccion}
            onChange={({ target }) =>
              setState({
                ...state,
                direccion: target.value.toUpperCase(),
              })
            }
            inputProps={{
              maxLength: 200,
            }}
            multiline
            maxRows={2}
          />

          <TextField
            fullWidth
            label="Referencia 1"
            size="small"
            color="success"
            className="mb-15"
            value={state.referencia1}
            onChange={({ target }) =>
              setState({
                ...state,
                referencia1: target.value.toUpperCase(),
              })
            }
            inputProps={{
              maxLength: 100,
            }}
            multiline
            maxRows={2}
          />
          <TextField
            fullWidth
            label="Referencia 2"
            size="small"
            color="success"
            className="mb-15"
            value={state.referencia2}
            onChange={({ target }) =>
              setState({
                ...state,
                referencia2: target.value.toUpperCase(),
              })
            }
            inputProps={{
              maxLength: 100,
            }}
            multiline
            maxRows={2}
          />
        </div>
        <div className="footer-guardar-domicilio">
          <div className="button-guardar" onClick={onGuardar}>
            Guardar
          </div>
        </div>
      </div>
    </div>
  );
};
